import React from 'react';
import InputField from 'forms/shared/fields/input'
import { Field } from 'redux-form';

const LoginFields = () => (
  <>
    <Field
      type="text"
      name="email"
      groupClassName="my-4"
      placeHolder="Email"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <Field
      type="password"
      name="password"
      groupClassName="mt-4 mb-2"
      placeHolder="Password"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName="text-action-danger text-xs slab"
      component={InputField}
    />
    <div className="flex flex-row-reverse mb-4">
      <a className="text-xs" href="/recovery">Forgot your password?</a>
    </div>
  </>
);

export default LoginFields;
